import { combineReducers } from "redux";
import commonState from "./commonState";

export default combineReducers({
  commonState,
});
